import React from 'react';

// Branded full-page loader: gold emblem with a soft pulse
export const BrandLoading = ({ line = 'Just a moment…', testId = 'brand-loading' }) => (
  <div className="flex min-h-screen items-center justify-center bg-page px-6" data-testid={testId}>
    <div className="text-center">
      <img
        src="/butler-direct-emblem.png"
        alt=""
        className="mx-auto h-16 w-16 animate-pulse opacity-90"
      />
      <p className="mt-5 text-sm font-medium text-slate-500">{line}</p>
      <div className="mx-auto mt-5 h-1 w-40 overflow-hidden rounded-full bg-hair">
        <div className="bd-skel h-full w-full" />
      </div>
    </div>
  </div>
);

// Inline skeleton rows for tables and lists
export const SkeletonRows = ({ rows = 5, className = '', testId = 'skeleton-rows' }) => (
  <div className={`space-y-2 ${className}`} data-testid={testId}>
    {Array.from({ length: rows }).map((_, index) => (
      <div key={index} className="bd-skel h-11 w-full" style={{ animationDelay: `${index * 90}ms` }} />
    ))}
  </div>
);

export const SkeletonCards = ({ count = 3, className = '', testId = 'skeleton-cards' }) => (
  <div className={`space-y-3 ${className}`} data-testid={testId}>
    {Array.from({ length: count }).map((_, index) => (
      <div key={index} className="bd-card p-4" style={{ animationDelay: `${index * 90}ms` }}>
        <div className="bd-skel mb-3 h-4 w-1/3" />
        <div className="bd-skel mb-2 h-3 w-2/3" />
        <div className="bd-skel h-3 w-1/2" />
      </div>
    ))}
  </div>
);

export default BrandLoading;
